import slideFnc from './slide_fnc.js';
import uaNum from './uaJudgment.js';

/**
 * アコーディオン
 * @constructor
 * @author ERINA MORISAKI
 */
class Accordion {
  /**
   * @param {string} this.addClassNameval 付与するクラス名。
   * @param {object} this.slideFnc 使用するモジュールの機能。今回使用しているのはスライドアップ、ダウンの機能。
   * @param {object} this._optionInit オプション。
   * @param {string} this._optionInit.triggerClassName トリガーの対象となるクラス名。
   * @param {number} this._optionInit.slideTime アニメーションする時間の指定。
   * @param {boolean} this._optionInit.toggleFlg トグル機能を使用するか判定するフラグ。使用する際はtrue。不使用な際は省略。
   */
  constructor(option) {
    this._addClassNameval = 'is-open';
    this._slideFnc = slideFnc;
    this._uaNum = uaNum;
    this._optionInit = {
      triggerClassName: '.js-accordion-trigger',
      triggerClassName_footer: '.js-accordion-footer-trigger',
      slideTime: '400',
      toggleFlg: false
    };

    if (option) { // インスタンス化時にoptionが設定されていた場合
      this._optionInit = Object.assign(this._optionInit, option);
    }

    this.init();
  }
  init() {
    this.accordion(this._optionInit.triggerClassName, this._optionInit.toggleFlg);

    if (this._uaNum === 1) { //SPだった場合
      // SP時のみのfooterのアコーディオン処理
      this.accordion(this._optionInit.triggerClassName_footer, this._optionInit.toggleFlg);
    }
  }
  accordion(element, style) {
    const slideToggleBtn = document.querySelectorAll(element);
    this._elementName = element;
    slideToggleBtn.forEach((accordionTrigger, index) => {
      accordionTrigger.addEventListener('click', e => {
        const indexNum = index;
        let targetElem;

        // footerのアコーデオンのみ、ターゲットが変わるので条件分岐させる
        if (element === '.js-accordion-footer-trigger') {
          targetElem = e.target.parentElement.nextElementSibling;
          e.target.parentElement.classList.toggle(this._addClassNameval);
        } else {
          targetElem = e.target.nextElementSibling;
          e.target.classList.toggle(this._addClassNameval);
        }

        this._slideFnc.slideToggle(targetElem, this._optionInit.slideTime);
        if (style) {
          slideToggleBtn.forEach((e, index) => {
            if (index !== indexNum) {
              this._slideFnc.slideUp(e.nextElementSibling, this._optionInit.slideTime);
            }
          });
        }
      });
    });
  }
}

export default Accordion;
